import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserContext } from "../Context/UserContext.tsx";
import SessionService from "../Services/SessionService.tsx";

const PlanSwitcher = () => {
	const { hasShareholderAccess, isGrowthTeam, isGrowthLeader, role } = useUserContext();
	const location = useLocation();
	const navigate = useNavigate();

	const isLeader = ["Leader", "CoLeader", "Leader & CoLeader"].includes(role);
	const canSwitchPlans = hasShareholderAccess && isGrowthTeam && !isLeader && !isGrowthLeader;

	// Only the user's own plan pages switch plans: not the admin page, the dashboard, or a reportee's plan.
	const segments = location.pathname.split("/").filter(Boolean);
	const isOwnShareholderPlan =
		segments[0] === "evaluationPlan" && (segments.length === 1 || segments.length === 4);
	const isOwnGrowthPlan = segments[0] === "growth" && segments[1] !== "reportee";

	if (!canSwitchPlans || !(isOwnShareholderPlan || isOwnGrowthPlan)) {
		return null;
	}

	const isGrowthPlan = isOwnGrowthPlan;

	return (
		<nav aria-label="Plan selection" className="flex justify-content-center px-3 pt-3">
			<div
				className="flex border-1 border-round overflow-hidden"
				style={{ borderColor: "var(--surface-300, #CBD5E1)" }}
			>
				<button
					type="button"
					aria-current={!isGrowthPlan ? "page" : undefined}
					onClick={() => {
						SessionService.setNavigateTo("EvaluationPlan");
						navigate("/evaluationPlan");
					}}
					className="border-none px-4 py-2 font-medium cursor-pointer"
					style={{
						background: !isGrowthPlan ? "var(--primary-color)" : "transparent",
						color: !isGrowthPlan ? "var(--primary-color-text)" : "var(--text-color)",
					}}
				>
					Shareholder Plan
				</button>
				<button
					type="button"
					aria-current={isGrowthPlan ? "page" : undefined}
					onClick={() => {
						SessionService.setNavigateTo("GrowthLandingPage");
						navigate("/growth");
					}}
					className="border-none px-4 py-2 font-medium cursor-pointer"
					style={{
						background: isGrowthPlan ? "var(--primary-color)" : "transparent",
						color: isGrowthPlan ? "var(--primary-color-text)" : "var(--text-color)",
					}}
				>
					Growth Plan
				</button>
			</div>
		</nav>
	);
};

export default PlanSwitcher;
